module.exports = __webpack_public_path__ + "static/media/sontho-2.fec660b7.png";